'use client';

import { BasePageProps, CMSTransformerDataType, Content } from 'types/common';
import ContentDetail from 'app/components/ContentDetail/ContentDetail';

export interface ArticlesPageProps extends BasePageProps {
  params: CMSTransformerDataType;
}

const ArticlesPage = (props: ArticlesPageProps) => {
  const { title = '', tagline = '' } = props?.data?.hero_section?.article_overview?.[0]?.overview || {};
  return (
    <>
      <ContentDetail type={Content.articles} {...props} title={title} tagline={tagline} />
    </>
  );
};

export default ArticlesPage;
